import { color } from '@nuvolo/nuux-theme/utils';
import styled, { css } from 'styled-components';

/**
 * Shared styles for read-only detail views using RecordPreview.
 * Used by FSM Work Order Preview and Alert (renamed to Exception) Record Preview, can be used in the future when we just want to display read only data.
 */
export const recordPreviewSectionStyles = css`
  .MuiGrid-container {
    border: 1px solid ${color('custom', 'formInputBorder')} !important;
    border-radius: 24px;
  }

  .MuiDivider-root {
    border: none !important;
    border-top: 1px solid ${color('custom', 'formInputBorder')} !important;
    height: 0;
  }
`;

export const recordPreviewLinkStyles = css`
  .record-preview-link {
    color: ${color('primary', 'middle')};
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      color: ${color('primary', 'dark')};
    }
  }
`;

const RecordPreviewSection = styled.div`
  ${recordPreviewSectionStyles}
  ${recordPreviewLinkStyles}
`;

export default RecordPreviewSection;
